import { render } from "./isGift.vue?vue&type=template&id=7543df6b"
import script from "./isGift.vue?vue&type=script&lang=js"
export * from "./isGift.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__